import { Suspense } from 'react';
import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';
import { SbSharedRefineMenuShippingFiltersWrapperLazy } from '../SbSharedRefineMenuShippingFilters/SbSharedRefineMenuShippingFiltersWrapperLazy.jsx';

const userFragment = graphql`
    fragment SbSharedRefineMenuFilterDeliveryOptions_user on User {
        ...SbSharedRefineMenuShippingFiltersWrapper_user
    }
`;
const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterDeliveryOptions_itemSearch on ItemSearchQueryConnection {
        appliedFilters {
            name
        }
    }
`;

export const SbSharedRefineMenuFilterDeliveryOptions = ({
    isClient,
    currency,
    user: userRef,
    itemSearch: itemSearchRef,
    submitOnBlur,
    refreshOnSubmit,
}) => {
    const user = useFragment(userFragment, userRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const { appliedFilters = [] } = itemSearch;

    if (!isClient) {
        return null;
    }
    return (
        <Suspense fallback="">
            <SbSharedRefineMenuShippingFiltersWrapperLazy
                user={user}
                currency={currency}
                submitOnBlur={submitOnBlur}
                appliedFilterNames={new Set(appliedFilters.map(f => f?.name))}
                refreshOnSubmit={refreshOnSubmit}
            />
        </Suspense>
    );
};

SbSharedRefineMenuFilterDeliveryOptions.propTypes = {
    user: PropTypes.object,
    isClient: PropTypes.bool,
    currency: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
    submitOnBlur: PropTypes.bool,
    refreshOnSubmit: PropTypes.bool,
};
